import { Box, Modal } from '@mui/material';
import { memo, useCallback, useEffect, useState } from 'react';
import { MINIMUM_ACCEPTABLE_RATING } from 'utils';

import { FeedbackStep } from './components/feedback-step';
import { RatingStep } from './components/rating-step';
import { TrustpilotStep } from './components/trustpilot-step';
import { modalContainerSx } from './styles';
import { ETrustpilotFeedbackStep, TTrustpilotFeedbackModalProps } from './trustpilot-feedback.types';

export const TrustpilotFeedbackModal = memo<TTrustpilotFeedbackModalProps>(({ isOpen, onClose, placement, day }) => {
  const [step, setStep] = useState<ETrustpilotFeedbackStep>(ETrustpilotFeedbackStep.RATING);
  const [rating, setRating] = useState<number | null>(null);

  const handleRate = useCallback((selectedRating: number): void => {
    setRating(selectedRating);

    if (selectedRating < MINIMUM_ACCEPTABLE_RATING) {
      setStep(ETrustpilotFeedbackStep.FEEDBACK);
    } else {
      setStep(ETrustpilotFeedbackStep.TRUSTPILOT);
    }
  }, []);

  const handleFeedbackSubmit = useCallback((): void => {
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) {
      setStep(ETrustpilotFeedbackStep.RATING);
      setRating(null);
    }
  }, [isOpen]);

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box sx={modalContainerSx}>
        {step === ETrustpilotFeedbackStep.RATING && (
          <RatingStep onRate={handleRate} onClose={onClose} placement={placement} day={day} />
        )}
        {step === ETrustpilotFeedbackStep.FEEDBACK && (
          <FeedbackStep
            rating={rating}
            onSubmit={handleFeedbackSubmit}
            onClose={onClose}
            placement={placement}
            day={day}
          />
        )}
        {step === ETrustpilotFeedbackStep.TRUSTPILOT && (
          <TrustpilotStep onClose={onClose} placement={placement} day={day} />
        )}
      </Box>
    </Modal>
  );
});
